import LinkButton from 'flarum/components/LinkButton';

/* global m, app */

const ACTIVE_ROUTES = [
    'formulaireFormIndex',
    'formulaireFormIndexDiscussion',
    'formulaireFormIndexUser',
    'formulaireFormEdit',
    'formulaireSubmissionIndex',
];

export default class SettingsLinkButton extends LinkButton {
    static initProps(props) {
        props.active = this.isActive(props);
        props.config = m.route;
        props.icon = 'fas fa-poll-h';
        props.href = app.route('formulaireFormIndex');
        props.children = app.translator.trans('kilowhat-formulaire.forum.nav.forms');
    }

    static isActive(props) {
        return m.route() === props.href || ACTIVE_ROUTES.indexOf(app.current.props.routeName) !== -1;
    }
}
